import React from 'react'
import Nav from './Nav'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
import { useLanguage } from '../../context/LanguageContext'

const SKIP_LINK = { EL: 'Μετάβαση στο περιεχόμενο', EN: 'Skip to content' }

// Every page's nav and footer. The nav floats over the top of the page and sticks to the
// top of the window; each page's header leaves room for it with <NavSpace />. From the page
// context (gatsby-node.js): `theme` (the Nom-Nom colours) and `alternates`, the page's URL
// in each language.
const Layout = ({ children, theme, alternates }) => {
  const { lang } = useLanguage()

  return (
    <>
      {/* Lets keyboard users jump past the nav; it shows when it gets focus */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] focus:px-4 focus:py-2 focus:rounded-full focus:bg-ink focus:text-paper"
      >
        {SKIP_LINK[lang] || SKIP_LINK.EL}
      </a>
      <div className="sticky top-0 z-50 h-0">
        <Nav variant={theme} alternates={alternates} />
      </div>
      {/* overflow-x: clip keeps elements sliding in from the side (entrance animations) from
          making the page wider than the screen, which made phones and tablets zoom and jitter.
          Unlike overflow: hidden, it doesn't make <main> a scroll container. */}
      <main id="main" tabIndex={-1} className="outline-none overflow-x-clip">
        {children}
      </main>
      <Footer variant={theme} />
      <CookieBanner />
    </>
  )
}

export default Layout
